import { Endpoint } from '../endpoint';
import { CompanyResponse, CompanyId } from '@business/entities/companies';
import { CommonService } from '@business/services';

export function fetchCompanies() {
  return Endpoint.get<CompanyResponse[]>(`@gc/companies`);
}

export function fetchCompany(id: CompanyId, isPublic = false) {
  return Endpoint.get<CompanyResponse>(`@gc/${isPublic ? 'public/' : ''}companies/company/${id}`);
}

export function createCompany(company: Partial<CompanyResponse>) {
  return Endpoint.post<CompanyResponse>(`@gc/companies/create`, { data: { ...company } });
}

export function updateCompany(id: CompanyId, company: Partial<CompanyResponse>) {
  const formData = CommonService.toFormData(company);
  return Endpoint.post<CompanyResponse>(`@gc/companies/${id}`, { formData, hasFiles: true });
}

export function deleteCompany(companyId: CompanyId) {
  return Endpoint.delete<void>(`@gc/companies/${companyId}`);
}

export function updateCompanyContent(id: CompanyId, company: Partial<CompanyResponse>) {
  return Endpoint.patch<CompanyResponse>(`@gc/companies/content/${id}`, { data: { ...company } });
}

export function removeLogo(id: CompanyId, type: string) {
  return Endpoint.post<CompanyResponse>(`@gc/companies/remove-logo/${id}`, { data: { type } });
}

export function updateNotifications(notifications: any) {
  return Endpoint.post<CompanyResponse>(`@gc/companies/notifications`, { data: { notifications } });
}

export function updateEmailNotifications(notifications: any) {
  return Endpoint.post<CompanyResponse>(`@gc/companies/email-notifications`, { data: { notifications } });
}
